import React from 'react';
import { useArticlesGet, Article } from '../../../../hooks/api/article';
import { IconInfoTrac, IconInfoPublisher } from '../../../Common/Icon';
import CardSlider from '../../Home/RecentArticles/CardSlider';

interface Props {
  productId: string;
  productName: string;
  productLogo: string;
}

export default function ProductUpdate({ productId, productName, productLogo }: Props): React.ReactNode {
  const articlesGet = useArticlesGet({ params: { pageSize: '100', status: 'published' } });

  const articles: Article[] = articlesGet.data?.data
    .filter((a) => a.product.id === productId && a.status === 'published')
    .slice(0, 8) ?? [];

  const icon = productName === 'InfoTRAC'
    ? <IconInfoTrac width={24} opacity={0.5} />
    : <IconInfoPublisher width={24} opacity={0.5} />;

  return (
    <div>
      <div style={{ padding: '32px 0 16px' }}>
        <h2 style={{ color: '#284F66' }}>Product updates</h2>
      </div>
      <CardSlider data={articles} icon={productLogo} label={productName} />
    </div>
  );
}
